import {
  Body,
  Flex,
  Heading,
  VStack,
  system,
  useTheme,
} from '@hover/blueprint';
import { iconPlus } from '@hover/icons';
import React from 'react';

import { BasicCard } from 'src/modules/homeownerApp/components/Card';
import { Button } from 'src/shared/components';
import type { ButtonPressed } from 'src/shared/telemetry';

import { useProTranslate } from '../../hooks';

const TryItCard = ({
  onTryItCardClick,
  ctaTrackingData,
}: {
  onTryItCardClick: () => void;
  ctaTrackingData: Partial<ButtonPressed>;
}) => {
  const t = useProTranslate();
  const { colors } = useTheme();

  const { job_id: _, ...relevantTrackingData } = ctaTrackingData;

  return (
    <BasicCard
      backgroundColorProp={colors.neutral[50]}
      paddingX={{
        base: 500,
        tablet: 700,
        desktop: 500,
        width500: 700,
      }}
      paddingY={{
        base: 800,
        tablet: 700,
        desktop: 500,
        width500: 700,
      }}
      width="100%"
    >
      <Flex
        alignItems={{
          base: 'flex-start',
          tablet: 'center',
          desktop: 'flex-start',
        }}
        flexDirection={{ base: 'column', tablet: 'row', desktop: 'column' }}
        height="100%"
        justifyContent={{ base: 'center', tablet: 'space-between' }}
      >
        <VStack
          alignItems="flex-start"
          flexGrow={1}
          pb={{ base: 500, tablet: 0, desktop: 200 }}
        >
          <Heading
            fontWeight="bold"
            mb={{ base: 200, tablet: 100, desktop: 200 }}
            size={{ tablet: 500, desktop: 300, width500: 500 }}
          >
            {t('tryItCard.header')}
          </Heading>
          <Body
            size={{ tablet: 300, desktop: 200, width500: 300 }}
            textColor="neutral.600"
          >
            <system.span display={{ base: 'inline', tablet: 'none' }}>
              {t('tryItCard.subHeader.mobile')}
            </system.span>
            <system.span display={{ base: 'none', tablet: 'inline' }}>
              {t('tryItCard.subHeader.tablet')}
            </system.span>
          </Body>
        </VStack>
        <Button
          iconBefore={iconPlus}
          marginLeft={{ base: 0, tablet: 700, desktop: 0 }}
          onClick={onTryItCardClick}
          optionalTrackingProperties={relevantTrackingData}
          size={{ base: 'large', desktop: 'medium', width500: 'large' }}
          width={{ base: '100%', tablet: 'fit-content', desktop: '100%' }}
        >
          {t('tryItCard.buttonText')}
        </Button>
      </Flex>
    </BasicCard>
  );
};

export { TryItCard };
